<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	//Stores
	import { home_data } from 'src/stores/account/user';

	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { save_home } from 'src/helpers/home_helpers';

	//Design system components
	import { Alert, Toggle } from '@Shelly/shelly-design-system';

	let checked = $home_data.bgBtScan == undefined ? true : $home_data?.bgBtScan?.enable;

	let disabled = false;

	const save = async (e) => {
		checked = e.target.checked;

		save_home('bgBtScan', {
			enable: checked,
		});

		home_data.set({
			...$home_data,
			bgBtScan: {
				enable: checked,
			},
		});

		if (checked) {
			// toast.open({
			// 	type: 'success',
			// 	title: capFirstChar(
			// 		$format('toast_background_scan_setting_enable', {
			// 			default: 'discovery of devices in the background is enabled'
			// 		})
			// 	)
			// });
		} else {
			// toast.open({
			// 	type: 'success',
			// 	title: capFirstChar(
			// 		$format('toast_background_bluetooth_scan_setting_disable', {
			// 			default: 'discovery of devices in the background is disabled'
			// 		})
			// 	)
			// });
		}
	};
</script>

<!-- {#if $app && $os !== 'IOS'}
	<Alert
		class="mb-s"
		type="warning"
		isHeadingBold
		heading={capFirstChar(
			$format('alert_warning_local_control_setting', {
				default: 'Attention!'
			})
		)}
		message={capFirstChar(
			$format('alert_warning_background_scan_setting_android', {
				default:
					'This functionality is temporary disabled for Android devices. We are working on a solution. Sorry for the inconvenience.'
			})
		)}
	/>
{/if} -->

<Alert
	class="mb-m"
	type="warning"
	isHeadingBold
	heading={capFirstChar(
		$format('alert_warning_generic_attention', {
			default: 'Attention!',
		}),
	)}
	message={capFirstChar(
		$format('alert_warning_message_background_scan_setting', {
			default:
				'In order to use this feature, the app must have location and Bluetooth permission enabled.',
		}),
	)}
/>

<Alert
	class="mb-m"
	heading={capFirstChar(
		$format('alert_info_background_scan_setting', {
			default:
				'When enabled, the app will look for new devices in the background and prompt on discovery. This may consume more battery.',
		}),
	)}
/>

<Toggle class="mb-s" id="toggle-background-scan" bind:checked size="m" {disabled} on:click={save}>
	{$format('input_toggle_background_scan_setting', {
		default: 'Enable background scan for new devices',
	})}
</Toggle>
